import Swiper from "swiper"

export default class LBSLider {

  constructor(el) {
    this.el = el
    this.slider = null
  }

  init () {
    this.initEvents()
    this.toggleSlider()
  }

  initEvents () {
    window.addEventListener('resize', () => this.toggleSlider())
  }

  toggleSlider () {

    if (window.innerWidth < 768) {
      this.initSlider()
    } else {
      this.destroySlider()
    }
      
  }

  initSlider () {

    if (this.slider) return

    this.slider = new Swiper(this.el, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      watchOverflow: true,
      observer: true
    })

  }

  destroySlider () {

    if (!this.slider) return

    this.slider.destroy()
    this.slider = null

  }

}